<script setup lang="ts">
/**
 * APIエラー時表示用コンポーネント。
 */
</script>

<template>
	<section class="revico-api-error">
		<p>現在、ご利用いただけません。<br />画面を更新するか、時間をあけて再度お試しください。</p>
	</section>
</template>

<style lang="scss">
.revico-widget {
	.revico-api-error {
		margin: 12px 0;
		text-align: center;
	}
}
</style>
